export default "__VITE_ASSET__c2a25732__"